import { $inputRule, $prose } from '@milkdown/utils';
import { linkSchema } from '@milkdown/preset-commonmark';
import { TextSelection, Plugin, PluginKey } from '@milkdown/prose/state';
import { InputRule } from '@milkdown/prose/inputrules';
// matches [foo](https://link.com), but does not match ![foo](https://link.com)
export const LINK_INPUT_REGEX = /(?<!!)\[([^\]]+)]\(([^)]+)\)\s?$/;
// matches <https://link.com> or <www.google.com>
export const AUTOLINK_INPUT_REGEX = /<([^>]+)>\s?$/;
// matches https://link.com
export const URL_REGEX = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/;
export const insertLinkInputRule = $inputRule(ctx => new InputRule(LINK_INPUT_REGEX, (state, match, start, end) => {
    const [matched, content, href = ''] = match;
    if (!matched) {
        return null;
    }
    const linkMark = linkSchema.type(ctx).create({ href });
    const tr = state.tr.replaceWith(start, end, state.schema.text(content, [linkMark]));
    tr.setSelection(TextSelection.near(tr.doc.resolve(start + content.length)));
    return tr;
}));
// Support markdown link syntax for autolinks (like <https://example.com>)
export const autolinkInputRule = $inputRule(ctx => new InputRule(AUTOLINK_INPUT_REGEX, (state, match, start, end) => {
    const [matched, url = ''] = match;
    if (!matched) {
        return null;
    }
    const linkMark = linkSchema.type(ctx).create({ href: url });
    const tr = state.tr.replaceWith(start, end, state.schema.text(url, [linkMark]));
    tr.setSelection(TextSelection.near(tr.doc.resolve(start + url.length + 1)));
    tr.setStoredMarks(null);
    return tr;
}));
export const pasteUrlPlugin = $prose(ctx => {
    return new Plugin({
        key: new PluginKey('paste-url-handler'),
        props: {
            handlePaste(view, event) {
                const text = event.clipboardData?.getData('text/plain');
                if (!text) {
                    return false;
                }
                const trimmedText = text.trim();
                const isUrl = URL_REGEX.test(trimmedText);
                if (isUrl) {
                    const { state, dispatch } = view;
                    const { selection } = state;
                    const { from, to } = selection;
                    const linkMark = linkSchema.type(ctx).create({
                        href: trimmedText,
                    });
                    const tr = state.tr.replaceWith(from, to, state.schema.text(trimmedText, [linkMark]));
                    dispatch(tr);
                    return true;
                }
                return false;
            },
        },
    });
});
//# sourceMappingURL=input_rules.js.map